import React, { PropsWithChildren } from 'react';
import styles from './style.module.scss';
import { listingPageModalIds } from 'constants/test-constants';

type DetailsTableProps = PropsWithChildren<{
  isPrivate: boolean;
}>;

export default function DetailsTable({ isPrivate, children }: DetailsTableProps) {
  return (
    <div className={`${styles.component} ${isPrivate && styles['is-private']}`} data-testid={listingPageModalIds.detailsTable}>
      <section>
        {children}
      </section>
    </div>
  );
}